
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feedback_2_svg__iconSvg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 65 65","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414","class":"feedback_2_svg__iconSvg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.59 28.887c3.076 0 5.57-2.532 5.57-5.656 0-3.124-2.494-5.657-5.57-5.657-3.075 0-5.569 2.533-5.569 5.657s2.494 5.656 5.57 5.656zM43.408 28.887c3.076 0 5.57-2.532 5.57-5.656 0-3.124-2.494-5.657-5.57-5.657s-5.57 2.533-5.57 5.657 2.494 5.656 5.57 5.656zM19.586 41.07l24.562 5.242.825-3.975-24.563-5.243-.824 3.975z"}}),_c('path',{attrs:{"d":"M9.023 65h45.954C59.95 65 64 60.888 64 55.836V9.164C64 4.112 59.951 0 54.977 0H9.023C4.05 0 0 4.112 0 9.164v46.672C0 60.888 4.049 65 9.023 65zM4 9.164c0-2.812 2.254-5.101 5.023-5.101h45.954c2.77 0 5.023 2.289 5.023 5.101v46.672c0 2.812-2.254 5.102-5.023 5.102H9.023C6.254 60.938 4 58.648 4 55.836V9.164z"}})])
          )
        }
      }
    